//@ts-nocheck
import React, { useEffect, useState } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import {
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { classNames } from "../../../utils/classNames";
import { useNavigate, useSearchParams } from "react-router-dom";
import useGetHook from "../../../customHooks/useGetHook";
import CreateIcon from "../../../Icons/CreateIcon";
import Spinner from "../Spinner";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";

import DownloadIcon from "../../../Icons/DownloadIcon";
import { downloadApiData } from "../../../helpers/AxiosInstance";
import moment from "moment";

interface IDataTable {
  url: string;
  queryKey: string;
  columns: any;
  addNewPagePath?: string;
  tableName: string;
  params?: any;
  scanComponent?: any;
  actionMenu?: any;
  setRerender?: any;
  isUpload?: boolean;
  isDownload?: boolean;
}

function SubDataTable(props: IDataTable) {
  const {
    url,
    queryKey,
    columns,
    addNewPagePath,
    scanComponent,
    actionMenu,
    params: otherParams,
    isUpload = false,
    isDownload = false,
  } = props;
  const [searchParams, setSearchParms] = useSearchParams({
    searchQuery: "",
  });
  const searchQuery = searchParams.get("searchQuery");
  const selectedItems = searchParams.get("selectedItems");
  const navigate = useNavigate();

  const [countSelectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    const items = selectedItems?.split(",");
    setSelectedItems(items?.length);
  }, [selectedItems]);

  const { data: serverData, isLoading } = useGetHook({
    queryKey: [
      queryKey,
      `${queryKey}-${searchQuery}-${JSON.stringify(
        otherParams
      )}`,
    ],
    url: url,
    params: {
      search: searchQuery,
      ...otherParams,
    },
  });
  const [data, setData] = useState([]);

  useEffect(() => {
    if (Array.isArray(serverData)) {
      setData([...serverData] ?? []);
      if (searchParams.get("selectAllItems") === "1") {
        let _newItems = serverData
          ?.map((item) => item.id)
          .join(",")
          .toString();
        setSearchParms({
          page: page,
          selectedItems: _newItems,
          selectAllItems: searchParams.get("selectAllItems"),
          searchQuery: searchQuery,
        });
      }
    }
  }, [serverData]);

  // Create the table and pass your options
  const table = useReactTable({
    data,
    columns,
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
  });

  const handleAddPageRoute = () => {
    navigate(addNewPagePath);
  }

  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);
    setSearchParms(searchParams);
  };

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <>
      <div
        className={tw`w-full bg-white rounded-sm mb-8 max-h-[600px] overflow-y-auto`}
      // style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      >
        <div
          className={tw`w-full grid grid-cols-1 gap-4 md:flex justify-between p-4`}
        >
          <div className={tw`text-primary w-full justify-end flex gap-x-4`}>
            <span className={tw`flex gap-x-1 w-full cursor-pointer`}>
              {actionMenu}
            </span>
          </div>
        </div>
        <div className={tw`w-full overflow-auto z-0`}>
          <table className={tw`w-full`}>
            <thead className={tw`bg-primary text-white uppercase`}>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id} className={tw``}>
                  {headerGroup.headers.map((header, index) => (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      className={classNames(
                        index === 0
                          ? tw``
                          : headerGroup.headers?.length - 1 === index
                            ? tw` text-left w-[8rem]`
                            : tw``,
                        tw`py-[5px] text-left px-5 whitespace-nowrap`
                      )}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr
                  key={row.id}
                  className={tw`tweven:bg-gray-50 odd:bg-white hover:bg-gray-100 hover:transition-all`}
                >
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id} className={tw`py-[10px] text-left px-5`}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
            <tfoot>
              {table.getFooterGroups().map((footerGroup) => (
                <tr key={footerGroup.id}>
                  {footerGroup.headers.map((header) => (
                    <th key={header.id} colSpan={header.colSpan}>
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                          header.column.columnDef.footer,
                          header.getContext()
                        )}
                    </th>
                  ))}
                </tr>
              ))}
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
}

export default SubDataTable;
